module.exports = __webpack_public_path__ + "img/kaneko.37fbcec5.jpg";